import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

const HOST_TENANTS = new Map([
  ['profile.agrifirm.com', 'Agrifirm'],
  ['profile.staging.mcps.agrifirm.com', 'Agrifirm'],
  ['profile.c4htest.mcps.agrifirm.com', 'Agrifirm'],
  ['profile.avidata-agravis.de', 'Agravis'],
  ['profile-agravis.staging.mcps.agrifirm.com', 'Agravis'],
  ['profile-agravis.c4htest.mcps.agrifirm.com', 'Agravis'],
]);

export async function loadRuntimeEnvironment(
  buildEnvironment: Environment,
  hostname: string,
  buildId?: string,
  fetchConfig: typeof fetch = fetch,
): Promise<Environment> {
  const fallback = {
    ...buildEnvironment,
    TENANT: HOST_TENANTS.get(hostname.toLowerCase()) ?? buildEnvironment.TENANT,
  };
  try {
    const configUrl = buildId ? `/assets/config.json?v=${buildId}` : '/assets/config.json';
    const response = await fetchConfig(configUrl, { cache: 'no-store' });
    if (response.ok) {
      const config = parseAgrEnvironment(await response.json());
      return { ...fallback, ...config, TENANT: config.TENANT ?? fallback.TENANT };
    }
    console.warn('No runtime configuration found, using default environment settings.');
  } catch (e) {
    console.warn('Failed to load runtime environment variables', e);
  }
  return fallback;
}
